import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

import { defaultConfig, mergeConfig, type SiteConfig } from "./schema";

const ConfigContext = createContext<SiteConfig>(defaultConfig);

/** Runtime override location. Upload this file next to index.html on S3 to
 *  re-skin / re-content the site without a rebuild. */
const RUNTIME_CONFIG_URL = "/config/site.json";

export function ConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<SiteConfig>(defaultConfig);

  useEffect(() => {
    let cancelled = false;
    fetch(RUNTIME_CONFIG_URL, { cache: "no-cache" })
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        if (!cancelled && json) setConfig(mergeConfig(json));
      })
      .catch(() => {
        /* no runtime override present — bundled defaults stand */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig(): SiteConfig {
  return useContext(ConfigContext);
}
